export default [
    {
        label: 'Approval METC/BoD',
        image: 'approval',
        value: 1,
    },

    {
        label: 'Patient Enrollment',
        image: 'patient-enrollment',
        value: 2,
    },

    {
        label: 'Database Lock',
        image: 'database-lock',
        value: 3,
    },

    {
        label: 'Publication',
        image: 'publication',
        value: 4,
    },
];
